// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, Box, Stack, Text, Flex, Divider } from '@locus-taxy/neo-ui';
import { rankWith, uiTypeIs } from '@jsonforms/core';

import useClientId from 'common/hooks/useClientId';

import MaraOnlyTag from '../components/MaraOnlyTag';
import useControlProps from '../util/useControlProps';

export const ChecklistSettingsLink = (props: $FixMe): React.Node => {
    const {
        visible,
        uischema: { options }
    } = useControlProps(props);

    const { isMaraOnlyField } = options || {};

    const { t } = useTranslation('platform');

    const history = useHistory();
    const clientId = useClientId();

    const handleActionClick = () => {
        history.push(`/client/${clientId}/settings/trackIQ/checklist`);
    };
    const label = t(
        'settings.trackIQ.fields.appConfig.fields.checklistSetting.fields.checklistSettingsLink.label'
    );
    const description = t(
        'settings.trackIQ.fields.appConfig.fields.checklistSetting.fields.checklistSettingsLink.description'
    );
    const actionText = t(
        'settings.trackIQ.fields.appConfig.fields.checklistSetting.fields.checklistSettingsLink.actionButtonLabel'
    );

    return (
        visible && (
            <Box padding={4} backgroundColor="white" borderRadius={4}>
                <Stack space="xSmall">
                    <Flex justifyContent="space-between">
                        <Text fontSize={2} fontWeight={400}>
                            {label}
                        </Text>
                    </Flex>
                    {description || isMaraOnlyField ? (
                        <>
                            <Divider color="grey.200" />
                            <Flex justifyContent="space-between">
                                {description && (
                                    <Text
                                        color="grey.600"
                                        fontSize={2}
                                        fontWeight={400}
                                    >
                                        {description}
                                    </Text>
                                )}
                                {/* Show an indicator for the fields which is visible only to Mara personnel */}
                                {isMaraOnlyField && (
                                    <Box ml="auto">
                                        <MaraOnlyTag />
                                    </Box>
                                )}
                            </Flex>
                        </>
                    ) : null}
                    <Box ml="auto">
                        <Button palette="primary" onClick={handleActionClick}>
                            {actionText}
                        </Button>
                    </Box>
                </Stack>
            </Box>
        )
    );
};

export default ChecklistSettingsLink;

export const checklistSettingsLinkTester = rankWith(
    1,
    uiTypeIs('ChecklistSettingsLink')
);
